import { connect } from 'react-redux';
import UserId from './CreateUserId';
import { setUserId } from './CreateUserId.actions';

const mapDispatchToProps = {
  saveUserId: setUserId,
};

export default connect(null, mapDispatchToProps)(UserId);
